// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1KfLc","actions":"GroupTable_actions__mfdP2","deleteModalFooter":"GroupTable_deleteModalFooter__2nw6Q"};